<template>
  <div>
    <step :navItems="navItems" :index="1" :step="step" v-on:step="updateStep" v-on:back="() => { this.$router.push('/group-mgr') }">
      <template slot="header">
        <h3>{{$t('add_student')}}</h3>
      </template>

      <template slot="body">
        <div class="row">
          <div class="col-sm-4 offset-sm-4">
            <form class="form-custom pt-0 bg-white">
              <label class="sr-only">{{$t('username')}}</label>
              <input type="text" class="form-control mt-3 rounded" :placeholder="$t('Please_enter_username')" required v-model="student.userName">

              <label class="sr-only">{{$t('password')}}</label>
              <input type="password" class="form-control mt-3 rounded" :placeholder="$t('Please_enter_password')" required v-model="student.password">

              <label class="sr-only">{{$t('name')}}</label>
              <input type="text" class="form-control mt-3 rounded" :placeholder="$t('Please_enter_user_name')" required v-model="student.realName">

              <label class="sr-only">{{$t('student_id')}}</label>
              <input type="text" class="form-control mt-3 rounded" :placeholder="$t('Please_enter_student_id')" required v-model="student.studentNo">
            </form>
          </div>
        </div>
      </template>
    </step>

    <step :navItems="navItems" :index="2" :step="step" v-on:step="updateStep" v-on:finish="() => { this.$router.push('/group-mgr') }">
      <template slot="header">
        <h3>{{$t(_finish)}}</h3>
      </template>

      <template slot="body">
        <div class="col-8 offset-2">
          <ul class="list-group list-group-flush">
            <li class="list-group-item border text-left mb-3 rounded"
              style="line-height: 150%;">
              <span>
                {{ student.realName }}<br>{{$t('generated_time')}}：{{ now }}
              </span>
              <span class="float-right"></span>
            </li>
          </ul>
        </div>
      </template>
    </step>
  </div>
</template>

<script>
import Step from './Step'
import api from '../../store/api'

export default {

  name: 'TeachingGroupAddStudent',

  components: {
    Step
  },

  data () {
    return {
      groupId: null,
      createTime: '',
      step: 1,
      student: {
        userName: '',
        password: '',
        realName: '',
        studentNo: ''
      },
      navItems: [this.$t('add_or_select_list'), this.$t('input_data'), this.$t('_finish')]
    }
  },

  computed: {
    mode () {
      return (this.$route.name === 'group-mgr.student.add') ? 'add' : 'edit'
    },

    now () {
      let d = new Date()
      return d.getFullYear() + '-' + d.getMonth() + '-' + d.getDate()
    }
  },

  async mounted () {
    this.groupId = this.$route.params.groupId
  },

  methods: {
    updateStep (step) {
      if (step === 2) {
        this.add()
      }

      this.step = step
    },

    async add () {
      let fileData = new window.FormData()
      fileData.append('userName', this.student.userName)
      fileData.append('password', this.student.password)
      fileData.append('realName', this.student.realName)
      fileData.append('studentNo', this.student.studentNo)

      const { data } = await api.post('/GroupMgr/TeachingGroups/' + this.groupId + '/Student/Create', fileData)

      if (data.status === 'OK') {
        this.addStudentToGroup(data.data.id)
      }
    },

    async addStudentToGroup (studentId) {
      let groupForm = new window.FormData()
      groupForm.append('studentIds', [studentId])

      const { data } = await api.post('/GroupMgr/TeachingGroups/' + this.groupId + '/Students', groupForm)

      if (data.status === 'OK') {
        console.log(data)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/style/color.scss';

.list-group-item.active {
  background-color: $main-color;
}
</style>


// WEBPACK FOOTER //
// TeachingGroupAddStudent.vue?50c12b1e